module.exports = __webpack_public_path__ + "static/img/wyvern.f96c7f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/monster/wyvern.png
// module id = y6ry
// module chunks = 0